import React from "react";
import "../Style/saassbs.css";

import inventory from "../assets/intern_1 2.png";
import trapLeft from "../assets/left-corner.png";
import trapRight from "../assets/right-corner.png";
import LetsBuild from "./LetsBuild";

const services = [
  {
    id: 1,
    title: "SaaS Product Development",
    description:
      "We build scalable SaaS products tailored to your business model, delivering secure, cloud-based solutions with exceptional performance and seamless user experiences.",
    position: "top-left",
  },
  {
    id: 2,
    title: "SaaS UI/UX Design",
    description:
      "Our designers create intuitive, user-centric SaaS interfaces that simplify workflows, improve usability, and maximize customer engagement.",
    position: "top-right",
  },
  {
    id: 3,
    title: "Cloud SaaS Application Development",
    description:
      "We develop secure cloud-native SaaS applications with multi-tenant architecture, ensuring flexibility, high availability, and business scalability.",
    position: "bottom-left",
  },
  {
    id: 4,
    title: "SaaS Maintenance & Support",
    description:
      "Our dedicated team provides continuous monitoring, feature enhancements, security updates, and technical support to keep your SaaS platform running smoothly.",
    position: "bottom-right",
  },
];

export default function SaassbsServices() {
  return (
    <section className="saassbs-section">
      <img src={trapLeft} alt="" className="trap-left" />

      {/* Right trapezoid */}
      <img src={trapRight} alt="" className="trap-right" />

      <div className="saassbs-wrapper">
        {/* Header */}
        <div className="saassbs-header">
          <h1 className="saassbs-main-heading">
            Comprehensive SaaS Development Services
          </h1>
          <p className="saassbs-taglines">From Idea to Launch. Built to Scale.</p>
        </div>

        {/* Layout */}
        <div className="saassbs-layout">
          <div className="saash-divider"></div>
          <div className="saasv-divider"></div>

          {/* Center */}
          <div className="saascenter-circle">
            <img src={inventory} alt="logo" className="saassbs-logo-img" />
          </div>

          {/* Cards */}
          {services.map((service) => (
            <div
              key={service.id}
              className={`saassbs-card ${service.position}`}
            >
              <h3 className="saassbs-card-title">{service.title}</h3>

              <p className="saassbs-card-descs">{service.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="hwd-cta">
          <button className="saashwd-btn-primary">
            <LetsBuild /> ↗
          </button>

          
        </div>
      </div>
    </section>
  );
}
